<template>
  <div class="trash-list">
    <template v-if="list.length">
      <div class="trash-list__head">
        <div>{{ $t('nameLabel') }}</div>
        <div></div>
      </div>
      <div class="divide-y divide-border">
        <TrashListItem v-for="(item,i) in list" :key="i"
                       :item="item"
                       :type="listItemType"
                       @restored="$emit('itemRestored')"/>
      </div>
    </template>
    <div v-else class="text-xl font-bold text-text leading-tight text-center w-full mb-4">{{ $t('noData') }}</div>
  </div>
</template>

<script>
import BaseButton from "@/components/UI/BaseButton";
import TrashListItem from "@/components/cabinet/SpaceSettings/Trash/TrashListItem";

export default {
  name: "TrashList",
  components: {TrashListItem, BaseButton},
  props: {
    list: {
      type: Array
    },
    listItemType: {
      type: String
    },
    loading: {
      type: Boolean
    }
  },
  i18n: {
    messages: {
      en: {
        nameLabel: 'Element name',
        noData: 'No data'
      },
      ru: {
        nameLabel: 'Название элемента',
        noData: 'Нет данных'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.trash-list {
  &__head {
    @apply grid grid-cols-12 col-gap-4
    text-sm text-text-ternary py-4;
    grid-template-columns: 1fr auto;
  }

  &__item {
    @apply grid grid-cols-12 col-gap-4 items-center
    text-sm text-text-secondary py-4 font-bold;
    grid-template-columns: 1fr auto;
  }
}
</style>